<template>
	<view class="user-datail" :data-theme='theme()' :class="theme() || ''" v-if="!loading">
		<view class="top_box">
			<view class="user-header p20">
				<view class="user-info">
					<view class="photo">
						<image :src="user.avatarUrl" mode="aspectFill"></image>
					</view>
					<view class="info">
						<view class="name">{{ user.nickName }}</view>
					</view>
				</view>
			</view>
			<view class="top-tabbar">
				<scroll-view scroll-x="true" scroll-with-animation="true">
					<view class="type-list d-s-c">
						<view :class="type_active == item.type ? 'tab-item active' : 'tab-item '" v-for="(item, index) in types" :key="index" @click="tabTypeFunc(item.type)">
							{{ item.name }}
						</view>
					</view>
				</scroll-view>
			</view>
		</view>
		<scroll-view scroll-y="true" class="scroll-Y" :style="'height:' + scrollviewHigh + 'px;'" lower-threshold="50">
			<Points :user_id="user_id"></Points>
		</scroll-view>
			
	</view>
</template>

<script>
	import Popup from '@/components/uni-popup.vue'
	import Points from './user/points.vue'
	export default {
		components: {
			Points
		},
		data() {
			return {
				loading: true,
				/*兑换券详情*/
				user: {},
				// 选择的优惠内容
				type_active: 'points',
				types: [
					{
						type: 'points',
						name: '小票积分'
					}
				],
				scrollviewHigh: ''
			};
		},
		props: ['user_id'],
		onLoad(e) {
			
		},
		mounted() {
			this.init();
			/*获取订单详情*/
			this.getData();
		},
		methods: {
			/*初始化*/
			init() {
				let _this = this;
				uni.getSystemInfo({
					success(res) {
						_this.scrollviewHigh = res.windowHeight - 103;
					}
				});
			},
			/*tab切换*/
			tabTypeFunc(e) {
				if(e!=this.type_active){
					this.type_active = e;
				}
			},
			/*获取数据*/
			getData() {
				let self = this;
				uni.showLoading({
					title: '加载中'
				});
				self._get(
					'user.qrcode/detail', {
						user_id: self.user_id
					},
					function(res) {
						self.loading = false;
						self.user = res.data.user;
						
						// self.extractStore = res.data.order.extractStore;
						uni.hideLoading();
					},
					function(res) {
						uni.switchTab({
							url:'/pages/index/index'
						})
					}
				);
			},

			/*核销*/
			onSubmitExtract(user_coupon_id) {
				let self = this;
				if (self.project_id === '') {
					uni.showToast({
					    title: '请选择优惠项目',
					    duration: 2000,
						icon:'none'
					});
					return;
				}
				wx.showModal({
					title: "提示",
					content: "您确定要核销吗?",
					success: function(o) {
						o.confirm && self._post(
							'store.coupon/extract', {
								user_coupon_id: user_coupon_id,
								project_id: self.project_id
							},
							function(res) {
								uni.showToast({
									title: res.msg,
									duration: 2000,
									icon: 'success',
								});
								setTimeout(function () {
								    self.gotoPage('/pages/index/index');
								}, 2000);
							}
						);
					}
				});
			},
			/*点击单选*/
			radioChange(e) {
				let self = this;
				self.project_id = e;
			},
		}
	};
</script>

<style lang="scss" scoped>
	.user-header {
		position: relative;
		height: 100%;
		@include background_color('background_color');
	}
	
	.user-header .user-info {
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	
	.user-header .photo,
	.user-header .photo image {
		width: 50rpx;
		height: 50rpx;
		border-radius: 50%;
	}
	
	.user-header .photo {
		border: 2rpx solid #ffffff;
	}
	
	.user-header .info {
		padding-left: 20rpx;
		box-sizing: border-box;
		overflow: hidden;
		color: #FFFFFF;
	}
	
	.user-header .info .name {
		font-size: 26rpx;
	}
</style>
